import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  adminCards: [],
  payBoxes: [],
  filters: {
    cardNumber: null,
    userId: null,
    storeId: null,
    active: null,
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    payBoxesOptions(state) {
      return state.payBoxes.map(payBox => {
        const storeName = payBox.store?.name || payBox.store?.companyName || ''
        const description = [payBox.number, payBox.description].filter(Boolean).join(' - ')
        return {
          ...payBox,
          value: String(payBox.id),
          storeId: payBox.storeId ?? payBox.store?.id ?? null,
          label: storeName ? `${storeName} • ${description}` : description,
        }
      })
    },
  },

  mutations: {
    ...storePagination.mutations,

    SET_ADMIN_CARDS(state, adminCards) {
      state.adminCards = adminCards
    },
    SET_PAY_BOXES(state, payBoxes) {
      state.payBoxes = payBoxes
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, adminCards } = getInitialState()
      state.filters = filters
      state.adminCards = adminCards
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchAdminCards({ state, commit }) {
      const { data } = await axios.get('/api/admin-cards', {
        params: {
          cardNumber: state.filters.cardNumber || null,
          userId: state.filters.userId || null,
          storeId: state.filters.storeId || null,
          active: state.filters.active === null ? null : state.filters.active,
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state),
        },
      })

      commit('SET_ADMIN_CARDS', data.results || [])
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    async fetchAdminCardById(states, id) {
      const { data } = await axios.get(`/api/admin-cards/${id}`)
      return data
    },

    async fetchPayBoxes({ commit }) {
      const { data } = await axios.get('/api/sales/pay-box', {
        params: {
          active: 'true',
          payBoxType: 'SmartPos',
          pageSize: 0,
          pageIndex: 0,
        },
      })

      commit('SET_PAY_BOXES', data.results || [])
    },

    resetFilters({ commit }) {
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
